(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haypigs-slider-pro-1679997518"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1679998267"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1680178083"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1697537804"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1700059451"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1700664688"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1705603389"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1706882579"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1708417914"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1714665478"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1715677556"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1725980694"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1727956694"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1727956875"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1727957090"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1727957258"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1729776512"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1738932924"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1739378455"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1739379518"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1739450449"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1741100842"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1741783393"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1744295796"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1744641237"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1749038200"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider-pro-1750756261"]) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["haypigs-slider"] && !window.DesignMode) return;
  try {
    
  let hpslider = document.getElementById('hp-slider');
  if (hpslider) {
    var hpslider_init = new Flickity( hpslider, {
      freeScroll: false,
      contain: false,
      prevNextButtons: hpslider.dataset.controls,
      pageDots: hpslider.dataset.dots,
      setGallerySize: true,
      autoPlay: parseInt(hpslider.dataset.speed),
      pauseAutoPlayOnHover: false
    });
  }

  } catch(e) { console.error(e); }
})();
})();
